import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { useExtra } from "@/i18n/extra";

const Pricing = () => {
  const { pricing } = useExtra();
  const f = pricing.f;

  const proFeatures = [
    f.storage, f.contacts, f.deals, f.cases, f.calendar, f.reports, f.apps,
    f.campaigns, f.email, f.googleSync, f.quickbooks, f.sms, f.voice, f.creditCard, f.support,
  ];
  const freeFeatures = [
    f.storage, f.contacts, f.deals, f.cases, f.calendar, f.reports, f.apps, f.noSupport,
  ];
  const enterpriseFeatures = [...proFeatures, f.api];

  const tiers = [
    { ...pricing.tiers[0], features: freeFeatures, highlight: false },
    { ...pricing.tiers[1], features: proFeatures, highlight: true },
    { ...pricing.tiers[2], features: enterpriseFeatures, highlight: false },
  ];

  return (
    <section id="pricing" className="py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">{pricing.eyebrow}</span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            {pricing.title}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">{pricing.subtitle}</p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {tiers.map((t) => (
            <div
              key={t.name}
              className={`relative flex flex-col rounded-2xl border bg-card p-8 transition-all ${
                t.highlight
                  ? "border-primary shadow-elegant lg:scale-105"
                  : "border-border shadow-card hover:-translate-y-1 hover:shadow-soft"
              }`}
            >
              {t.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-gradient-primary px-3 py-1 text-xs font-semibold text-primary-foreground shadow-soft">
                  {pricing.mostPopular}
                </span>
              )}
              <h3 className="font-display text-2xl font-bold text-secondary">{t.name}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{t.blurb}</p>
              <div className="mt-6 flex items-baseline gap-1">
                <span className="font-display text-5xl font-extrabold text-secondary">{t.price}</span>
                <span className="text-muted-foreground">{pricing.perUserMo}</span>
              </div>
              <ul className="mt-6 flex-1 space-y-3">
                {t.features.map((feat) => (
                  <li key={feat} className="flex items-start gap-2 text-sm text-secondary">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                    {feat}
                  </li>
                ))}
              </ul>
              <Button asChild variant={t.highlight ? "hero" : "outline"} size="lg" className="mt-8 w-full">
                <a href="https://api.freecrm.com/register/?lang=en" target="_blank" rel="noopener noreferrer">
                  {t.cta}
                </a>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
